/*=========================================================================================
  File Name: actions.js
  Description: Order Manager Actions
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

import queries from "../../../services/orderManager/queries";

export default {
  async getOrderManagerStateAction ({commit, state, rootState }, payload) {

    await queries.getOrderManagerState(payload.restaurantId)
                .then( data => {
                  console.log(data)
                  commit('SET_ORDER_MANAGER_STATE', data)
                });
  },

  async getCurrentWaitingTimeAction({commit, state, rootState}, payload) {
    await queries.getCurrentWaitingTime(payload.restaurantId)
                .then(data => {
                  commit('SET_CURRENT_WAITING_TIME_STATE',data);
                })
  }
}